import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { CaseStageEnum } from "../../../../api/caseStages";
import {useAppSelector } from "../../../../app/store";
import { useLoggedInUserId } from "../../../auth/logic/rbac";
import {
  selectCurrentCaseStage,
} from "../../../caseinfo/logic/Slice";
import WorkflowStageBanner from "../../../stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../stageWorkflow/components/WorkflowStageInfoBanner";
import { selectStageConfigByStage } from "../../logic/slice";
import { ParticipantType } from "../../../../api/participants";

const FwdAuthInformationAdditionStage: React.FC = () => {
  const loggedInUserId = useLoggedInUserId();

  const forwardingAuthorityParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.FORWARDING_AUTHORITY)
  );

  const caseForwardingAuthority = forwardingAuthorityParticipant?.participant_id;
  const currentStage = useAppSelector(selectCurrentCaseStage);

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.FWD_AUTH_INFORMATION_ADDITION));

  const isForwardingAuthority = loggedInUserId === caseForwardingAuthority;

  if (isForwardingAuthority) {
    return (
      <WorkflowStageBanner
        title="Add Requested Information"
        description="Furnish the specific clarifications and documents as detailed in the comments. Your confirmation will re-submit the case for review."
        notes={currentStage?.stage_data?.notes}
        actions={stageConfig?.actions}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner title="Pending with Forwarding Authority to add additional information" />
  );
};

export default FwdAuthInformationAdditionStage;